import React from "react";


export const LocalizedPrice = ({ priceString }) => {
    const dotToComma = priceString.replace(/./g, ',');
    return parseFloat(priceString).toLocaleString('de-DE', { minimumFractionDigits: 2 }) + " €";
}